// Mood slider component (0-10) with emoji labels

export interface MoodSlider {
  root: HTMLElement;
  input: HTMLInputElement;
  getValue: () => number;
  setValue: (value: number) => void;
}

export function createMoodSlider(
  id: string,
  label: string,
  initialValue = 5,
  innerLabel: boolean
): MoodSlider {
  const wrapper = document.createElement('div');
  wrapper.className = 'space-y-2';

  const labelEl = document.createElement('label');
  labelEl.setAttribute('for', id);
  labelEl.className = 'text-sm font-medium text-gray-800 flex justify-between';
  if (innerLabel) {
    labelEl.innerHTML = `${label}`;
  }
  const input = document.createElement('input');
  input.type = 'range';
  input.id = id;
  input.min = '0';
  input.max = '10';
  input.step = '1';
  input.value = String(initialValue);
  input.className = 'w-full';
  input.setAttribute('aria-label', label);
  input.setAttribute('aria-valuemin', '0');
  input.setAttribute('aria-valuemax', '10');
  input.setAttribute('aria-valuenow', String(initialValue));

  const valueLabel = document.createElement('div');
  valueLabel.className = 'text-xs text-gray-600 text-right';
  valueLabel.textContent = `Mood: ${initialValue}`;

  input.addEventListener('input', () => {
    valueLabel.textContent = `Mood: ${input.value}`;
    input.setAttribute('aria-valuenow', input.value);
  });

  wrapper.appendChild(labelEl);
  wrapper.appendChild(input);
  wrapper.appendChild(valueLabel);

  return {
    root: wrapper,
    input,
    getValue: () => Number(input.value),
    setValue: (value: number) => {
      input.value = String(value);
      valueLabel.textContent = `Mood: ${value}`;
    },
  };
}
